import axios from 'axios';

import { StorageEnum } from '../enumerators/Storage.enum';

async function getDataByIdList(packageIdList: string[], fromStore: boolean) {
	return axios({
		method: 'post',
		url: `${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APP_DATA}/app/${fromStore ? 'fromStore' : 'fromCache'}`,
		timeout: 60 * 1000,
		data: {
			appIdList: packageIdList,
			lang: 'pt',
			country: 'br',
		},
	});
}

function getServerStatus(serverUrl: string, callback: Function) {
	fetchWithTimeout(`https://${serverUrl}/s1-modular-b2c-api/api/businessServerService/obterStatusServidor`, { headers: { Accept: 'application/json' }, timeout: 45 * 1000 })
		.then((res) => {
			callback(res.ok);
		})
		.catch((e) => {
			callback(false);
		});
}

function getS1Status(serverUrl: string, callback: Function) {
	fetchWithTimeout(`https://${serverUrl}/s1-api/bs/businessServerService/obterStatusServidor`, {
		method: 'POST',
		mode: 'cors',
		headers: { Accept: 'application/json', sistema: 1 },
		timeout: 45 * 1000,
	})
		.then(async (res) => {
			var response = await res.json();
			if (res.ok) {
				callback(response);
			} else {
				callback(response);
			}
		})
		.catch((e) => {
			callback(null);
		});
}

async function fetchWithTimeout(resource: any, options: any) {
	const { timeout = 8000 } = options;

	const controller = new AbortController();
	const id = setTimeout(() => controller.abort(), timeout);
	const response = await fetch(resource, {
		...options,
		signal: controller.signal,
	});
	clearTimeout(id);
	return response;
}

async function getS1Distributions(callback: Function, callbackError: Function) {
	const distributions = localStorage.getItem(StorageEnum.S1_DISTRIBUTIONS);

	if (distributions) {
		return callback(JSON.parse(distributions));
	}

	const gitlabtoken = localStorage.getItem(StorageEnum.GITLAB_TOKEN);

	fetchWithTimeout(`${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APP_DATA}/aws/listS1`, {
		method: 'GET',
		headers: { gitlabtoken: gitlabtoken },
		timeout: 120 * 1000,
	})
		.then(async (res) => {
			var response = await res.json();
			if (res.ok) {
				localStorage.setItem(StorageEnum.S1_DISTRIBUTIONS, JSON.stringify(response));

				callback(response);
			} else {
				callbackError(response);
			}
		})
		.catch((e) => {
			callbackError(null);
		});
}

async function getB2cDistributions(callback: Function, callbackError: Function) {
	const distributions = localStorage.getItem(StorageEnum.B2C_DISTRIBUTIONS);

	if (distributions) {
		return callback(JSON.parse(distributions));
	}

	const gitlabtoken = localStorage.getItem(StorageEnum.GITLAB_TOKEN);

	fetchWithTimeout(`${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APP_DATA}/aws/listB2c`, {
		method: 'GET',
		headers: { gitlabtoken: gitlabtoken },
		timeout: 120 * 1000,
	})
		.then(async (res) => {
			var response = await res.json();
			if (res.ok) {
				localStorage.setItem(StorageEnum.B2C_DISTRIBUTIONS, JSON.stringify(response));

				callback(response);
			} else {
				callbackError(response);
			}
		})
		.catch((e) => {
			callbackError(null);
		});
}

async function getGitLabTokens(): Promise<any> {
	const gitlabtoken = localStorage.getItem(StorageEnum.GITLAB_TOKEN);

	return new Promise((res, rej) => {
		fetchWithTimeout(`${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APP_DATA}/gitlab/tokens`, {
			method: 'GET',
			headers: { gitlabtoken: gitlabtoken },
			timeout: 120 * 1000,
		})
			.then(async (response) => {
				var responseJson = await response.json();
				if (response.ok) {
					localStorage.setItem(StorageEnum.GITLAB_PERSONAL_TOKEN, responseJson.personalToken);
					localStorage.setItem(StorageEnum.GITLAB_PIPELINE_TOKEN, responseJson.pipelineToken);
					res(true);
				} else {
					rej(response);
				}
			})
			.catch((e) => {
				rej(null);
			});
	});
}

async function getBitriseToken(): Promise<any> {
	const gitlabtoken = localStorage.getItem(StorageEnum.GITLAB_TOKEN);

	return new Promise((res, rej) => {
		fetchWithTimeout(`${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APP_DATA}/bitrise/token`, {
			method: 'GET',
			headers: { gitlabtoken: gitlabtoken },
			timeout: 120 * 1000,
		})
			.then(async (response) => {
				var responseJson = await response.json();
				if (response.ok) {
					localStorage.setItem(StorageEnum.BITRISE_TOKEN, responseJson.token);
					res(true);
				} else {
					rej(response);
				}
			})
			.catch((e) => {
				rej(null);
			});
	});
}

export { getB2cDistributions, getDataByIdList, getS1Distributions, getS1Status, getServerStatus, getGitLabTokens, getBitriseToken };
